import { useContext } from "preact/hooks";
import useTiltifyConfig from "@/hooks/useTiltifyConfig.js";
import useTwitchConfig from "@/hooks/useTwitchConfig.js";
import { buildCustomizedURL, isYes } from "@/util/common.js";
import { CHARITY } from "@/util/const.js";
import {
  useDeepSignalFromLocalStorage,
  useLocalDeepStorageKeyValue,
  useSignalWithLocalStorage,
} from "@/util/deepSignals.js";
import { ProductContext } from "../context/productContext.js";

export default function useCommon({
  config,
  urlBase,
  urlSuffix,
  urlSimplified = false,
  addTiltifyCampaign = true,
  addCharityType = true,
  forceTiltify = false,
}) {
  useDeepSignalFromLocalStorage(config);
  const setConfigState = useSignalWithLocalStorage(config);
  const setConfigKeyValue = useLocalDeepStorageKeyValue(config);
  const tiltifyConfig = useTiltifyConfig();
  const twitchConfig = useTwitchConfig();
  const overlayInfo = useContext(ProductContext);
  const useBetaOverlays = isYes(import.meta.env.VITE_BETA_OVERLAYS || "no");
  const overlayURL = buildCustomizedURL({
    config: forceTiltify
      ? {
          ...config,
          ...twitchConfig,
          ...tiltifyConfig,
          charityType: CHARITY.TILTIFY,
        }
      : {
          ...config,
          ...twitchConfig,
          ...tiltifyConfig,
        },
    urlBase: urlBase ? urlBase : `${useBetaOverlays ? "/overlays/" : ""}${overlayInfo.type}`,
    addCharityType,
    urlSuffix,
    urlSimplified,
    addTiltifyCampaign,
  });

  const overlayDemoURL = buildCustomizedURL({
    config: {
      ...config,
      ...twitchConfig,
      ...tiltifyConfig,
      charityType: CHARITY.TILTIFY,
      demoMode: "yes",
    },
    urlBase: urlBase ? urlBase : overlayInfo.type,
    addCharityType,
    urlSuffix,
  });

  return {
    overlayURL,
    overlayDemoURL,
    overlayInfo,
    setConfigState,
    setConfigKeyValue,
    twitchConfig,
    tiltifyConfig,
  };
}
